module.exports = __webpack_public_path__ + "static/cssmodules-2ce9c7048c83198fc804802dc7a5c4a2.png";